<template>
  <div class="common-box">
    <el-form
      inline
      ref="form"
      class="search-form common-box-search-form"
      label-position="right"
      :model="form"
      label-width="100px"
    >
      <search-form @search="handleSearch" @refresh="handleRefresh">
        <div slot="content">
          <el-form-item label="使用单位：">
            <el-select
              size="mini"
              v-model="form.propertyUnitId"
              filterable
              placeholder="请选择所属单位"
              clearable
              reserve-keyword
              :remote="true"
              @change="handleSearchListData"
              :remote-method="searchUnitList"
              @visible-change="searchUnitList('')"
            >
              <el-option
                v-for="item in unitList"
                :key="item.id"
                :label="item.unitName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属项目：">
            <el-select
              size="mini"
              v-model="form.projectId"
              filterable
              placeholder="请选择所属项目"
              clearable
              reserve-keyword
              :remote="true"
              @change="handleSearchListData"
              :remote-method="searchProjectList"
              @visible-change="searchProjectList('')"
            >
              <el-option
                v-for="item in projectList"
                :key="item.id"
                :label="item.projectName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="使用编号：">
            <el-input
              @change="handleSearchListData"
              size="mini"
              v-model.trim="form.useCertificateNumber"
              placeholder="请输入使用编号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="省市区：" class="input-with-col2">
            <AddreassSelect
              :isSearch="true"
              :warning="addressWarn"
              :showDetailAddress="showDetailAddress"
              :addressName="addressName"
              @change="setPojectAddress"
            ></AddreassSelect>
          </el-form-item>

          <el-form-item label="电梯位置：">
            <el-input
              @change="handleSearchListData"
              size="mini"
              v-model.trim="form.liftLocation"
              placeholder="请输入电梯位置"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="所属部门：">
            <el-cascader
              placeholder="请选择所属部门"
              :options="departmentTree"
              :props="propsTree"
              filterable
              @change="handleDepartment"
              ref="cascader"
              collapse-tags
              size="mini"
              v-model="departmentIdList"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="电梯类型：">
            <el-select
              size="mini"
              v-model="form.liftTypeCode"
              value-key="dictionaryCode"
              @change="handleSearchListData"
            >
              <el-option
                v-for="item in dtlxDicts"
                :key="item.dictionaryCode"
                :label="item.dictionaryValue"
                :value="item.dictionaryCode"
                placeholder="请选择电梯类型"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="运行状态：">
            <el-select
              size="mini"
              v-model="form.runningStatus"
              value-key="dictionaryCode"
            >
              <el-option
                v-for="item in yxztDicts"
                :key="item.dictionaryCode"
                :label="item.dictionaryValue"
                :value="item.dictionaryCode"
                placeholder="请选择运行状态"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="停保状态：">
            <el-select
              size="mini"
              v-model="form.maintainStatus"
              value-key="dictionaryCode"
            >
              <el-option
                v-for="item in tbztDicts"
                :key="item.dictionaryCode"
                :label="item.dictionaryValue"
                :value="item.dictionaryCode"
                placeholder="请选择停保状态"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间：">
            <el-date-picker
              v-model="form.createTimeBetween"
              size="mini"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd"
              unlink-panels
              clearable
               @change="handleSearchListData"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="是否有维修费：">
            <el-select
              size="mini"
              v-model="form.feeFlag"
              value-key="dictionaryCode"
              @change="handleSearchListData"
            >
              <el-option
                v-for="item in sfwxfDicts"
                :key="item.dictionaryCode"
                :label="item.dictionaryValue"
                :value="item.dictionaryCode"
                placeholder="请选择是否有维修费"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="维修时间：">
            <el-date-picker
              v-model="form.repairTimeBetween"
              size="mini"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd"
              unlink-panels
              clearable
               @change="handleSearchListData"
            ></el-date-picker>
          </el-form-item>
        </div>
      </search-form>
    </el-form>
    <div class="common-cover-div"></div>
    <div class="operation-and-table__container">
      <div class="btns__container">
        <el-button
          v-if="hasRole['DTDR']"
          size="mini"
          type="primary"
          class="plr28"
          @click="handleInput"
          >导入</el-button
        >
        <el-button
          size="mini"
          type="primary"
          @click="exportLiftList"
          plain
          class="plr28"
          v-if="hasRole['DTDC']"
          >导出</el-button
        >
        <el-button
          v-if="hasRole['DTTJ']"
          size="mini"
          type="primary"
          class="plr28"
          @click="handleAdd"
          plain
          >添加</el-button
        >
        <el-button
          size="mini"
          type="primary"
          class="plr28"
          @click="handleDelete"
          plain
          v-if="hasRole['DTSC']"
          >删除</el-button
        >
        <el-button
          size="mini"
          type="primary"
          class="plr28"
          @click="importRecords"
          plain
          v-if="hasRole['DTSC']"
          >导入记录</el-button
        >
        <span>年度维修费总计：{{ materialTotalRevenue }}</span>
        <span>年度维修费总计利润：{{ residualProfit }}</span>
      </div>
      <div class="table__container">
        <el-table
          v-loading="tableLoading"
          :data="list"
          height="100%"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="equipmentCode"
            label="设备编码"
            width="100"
            fixed="left"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="propertyUnitName"
            label="使用单位"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="projectName"
            label="项目名称"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="departmentName"
            label="所属部门"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="liftLocation"
            label="电梯位置"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="liftTypeName"
            label="电梯类型"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="maintainPerson"
            label="维保人员"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="recentlyMaintainTime"
            label="最近保养"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="nextMaintainTime"
            label="下次保养"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="annualInspectionDate"
            label="年检日期"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="nextAnnualInspectionDate"
            label="下次年检日期"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="installDate"
            label="安装日期"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="checkStr"
            label="检测/检验"
            width="100"
          >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.checkStr == '检测'" size= "mini" type="success"  effect="dark">{{scope.row.checkStr}}</el-tag>
            <el-tag v-if="scope.row.checkStr == '检验'" size= "mini" type="warning"  effect="dark">{{scope.row.checkStr}}</el-tag>
            </template>
          </el-table-column>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="maintainStatusName"
            label="是否停保"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="runningStatusName"
            label="运行状态"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="useCertificateNumber"
            label="使用证编号"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="shortCode"
            label="电梯短码"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="repairFeeForYear"
            label="年度维修费"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="repairFeeProfitForYear"
            label="年度维修费利润"
            width="110"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="creditCode"
            label="省市区街道"
            width="200"
          >
            <template slot-scope="scope">
              {{ scope.row.provinceName }}
              {{ scope.row.cityName }}
              {{ scope.row.districtName }}
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="createTime"
            label="创建时间"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="systemCode"
            label="系统编码"
            width="200"
          ></el-table-column>
          <el-table-column label=" " prop=" "></el-table-column>
          <el-table-column label="操作" width="150px" fixed="right">
            <template slot-scope="scope">
              <el-button
                size="mini"
                v-if="hasRole['DTBJ']"
                type="text"
                @click="handleEdit(scope.row)"
                >编辑</el-button
              >
              <div class="btn-divide" v-if="hasRole['DTBJ']"></div>

              <el-button
                size="mini"
                v-if="hasRole['DTSC']"
                type="text"
                @click="handleDeleteLift(scope.row)"
                >删除</el-button
              >
              <div class="btn-divide" v-if="hasRole['DTSC']"></div>
              <el-dropdown
                @command="(val) => handleCommand(val, scope.row)"
                szie="mini"
              >
                <span class="el-dropdown-link"> 更多 </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :disabled="!hasRole['DTFZ']" command="fuzhi"
                    >复制</el-dropdown-item
                  >
                  <el-dropdown-item
                    :disabled="!hasRole['DTZT']"
                    command="tingbao"
                    >{{
                      scope.row.maintainStatus == 2 ? "在保" : "停保"
                    }}</el-dropdown-item
                  >
                  <el-dropdown-item
                    :disabled="!hasRole['DTEWM']"
                    command="erweima"
                    >二维码</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <add-lift
      v-if="addLiftVisible"
      @cancel="addLiftVisible = false"
      @confirm="handleAddLiftConfirm"
    ></add-lift>
    <edit-lift
      v-if="editLiftVisible"
      :editData="liftDetail"
      @cancel="editLiftVisible = false"
      @confirm="handleEditLiftConfirm"
    ></edit-lift>
    <check-unit
      v-if="checkUnitVisible"
      :editData="liftDetail"
      @cancel="checkUnitVisible = false"
    ></check-unit>
    <check-code
      v-if="checkQrCode"
      :editData="liftDetail"
      @cancel="checkQrCode = false"
    ></check-code>
    <stop-maintain
      v-if="showStopMaintain"
      :editData="liftDetail"
      @confirm="stopMaintainConfirm"
      @cancel="showStopMaintain = false"
    ></stop-maintain>
    <start-maintain
      v-if="showStartMaintain"
      :editData="liftDetail"
      @confirm="startMaintainConfirm"
      @cancel="showStartMaintain = false"
    ></start-maintain>
    <import-dialog
      @cancel="showImport = false"
      @uploadFinish="uploadFinish"
      v-if="showImport"
      :importFun="importFun"
      :downFun="downFun"
    />
    <records v-if="showRecord" @cancel="showRecord = false"></records>
  </div>
</template>

<script>
import {
  getLiftList,
  deleteLift,
  getDepartmentTree,
  exportLiftTemplate,
  importLift,
  exportLiftList,
} from "@/api/ElevatorManagement";
import { getUnitSimpleList } from "@/api/ProjectManagement";
import { getProjectSimpleList } from "@/api/MaintenanceWorkOrder";
import AddLift from "./components/AddLift";
import EditLift from "./components/EditLift";
import CheckUnit from "./components/CheckUnit";
import CheckCode from "./components/CheckCode";
import AddreassSelect from "@/components/AddreassSelect/AddreassSelect";
import StopMaintain from "./components/StopMaintain";
import StartMaintain from "./components/StartMaintain";
import { mapState } from "vuex";
import { toNumber } from "lodash";
import ImportDialog from "@/components/ImportDialog/ImportDialog";
import Records from "./components/Records";
export default {
  name: "ElevatorManagement",
  components: {
    AddLift,
    EditLift,
    CheckUnit,
    CheckCode,
    AddreassSelect,
    StartMaintain,
    StopMaintain,
    ImportDialog,
    Records,
  },
  data() {
    return {
      form: {
        propertyUnitId: "",
        projectId: "",
        useCertificateNumber: "",
        cityCode: "",
        districtCode: "",
        provinceCode: "",
        liftLocation: "",
        departmentIdList: null,
        liftTypeCode: "",
        maintainStatus: "",
        runningStatus: "",
        createTimeBetween: null,
        repairTimeBetween: null,
        startCreateTime: "",
        endCreateTime: "",
        startRepairTime: "",
        endRepairTime: "",
      },
      residualProfit: '',
      materialTotalRevenue: '',
      tableLoading: false,
      list: [],
      multipleSelection: [],
      pageIndex: 1,
      pageSize: 50,
      total: 0,
      addLiftVisible: false,
      editLiftVisible: false,
      checkUnitVisible: false,
      checkQrCode: false,
      liftDetail: {},
      unitList: [],
      projectList: [],
      addressWarn: false,
      showDetailAddress: true,
      addressName: "省市区",
      showStopMaintain: false,
      showStartMaintain: false,
      departmentTree: [],
      propsTree: {
        multiple: true,
        value: "id",
        label: "departmentName",
        children: "childrenList",
        // checkStrictly: true
      },
      departmentIdList: [],
      showImport: false,
      importFun: importLift,
      downFun: exportLiftTemplate,
      showRecord: false,
    };
  },
  computed: {
    hasRole: function () {
      console.log(this.$route.path);
      return this.$store.getters["common/promise/getRole"](this.$route.path);
    },
    ...mapState("common/dictionary", ["yxztDicts", "tbztDicts", "dtlxDicts","sfwxfDicts"]),
  },
  created() {
    this.getListData();
    this.getDepartmentTree();
  },
  methods: {
    async getDepartmentTree() {
      const res = await getDepartmentTree({ pageIndex: 1, pageSize: 1000 });
      if (res.code === 200) {
        this.departmentTree = res.data;
      }
    },
    async searchProjectList(keyword) {
      const res = await getProjectSimpleList({
        keyword: keyword,
        size: 1000,
      });
      if (res.code === 200) {
        this.projectList = res.data;
      }
    },
    async searchUnitList(keyword) {
      const res = await getUnitSimpleList({
        keyword: keyword,
        size: 1000,
      });
      if (res.code === 200) {
        this.unitList = res.data;
      }
    },
    async getListData() {
      this.tableLoading = true;
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let key in this.form) {
        if (this.form[key]) params[key] = this.form[key];
      }
      if (params.createTimeBetween) {
        params.startCreateTime = this.form.createTimeBetween[0];
        params.endCreateTime = this.form.createTimeBetween[1];
      }
      delete params.createTimeBetween;
      if (params.repairTimeBetween) {
        params.startRepairTime = this.form.repairTimeBetween[0];
        params.endRepairTime = this.form.repairTimeBetween[1];
      }
      delete params.repairTimeBetween;
      const res = await getLiftList(params);
      if (res.code === 200) {
        this.total = res.data.total;
        this.list = res.data.list;
        console.log(res.data.statisticsData)
        if(res.data.statisticsData) {
          this.materialTotalRevenue = res.data.statisticsData.materialTotalRevenue;
          this.residualProfit = res.data.statisticsData.residualProfit;
        }
      }
      this.tableLoading = false;
    },
    handleSearch() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleRefresh() {
      for (let key in this.form) {
        if (Array.isArray(this.form[key])) {
          this.form[key] = [];
        } else {
          this.form[key] = "";
        }
      }
      this.pageIndex = 1;
      this.getListData();
    },
    handleSearchListData() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleDeleteLift(row) {
      const idList = [row.id];
      this.deleteLift(idList);
    },
    handleCheck(row) {
      this.liftDetail = row;
      this.checkQrCode = true;
    },
    handleEdit(row) {
      this.liftDetail = row;
      this.editLiftVisible = true;
    },
    handleEditCopy(row) {
      this.liftDetail = { ...row };
      this.liftDetail.copy = true;
      this.editLiftVisible = true;
    },
    handleDelete() {
      if (!this.multipleSelection.length) {
        this.$message.warning("请选择要删除的行");
        return;
      }
      const idList = this.multipleSelection.map((item) => item.id);
      this.deleteLift(idList);
    },
    deleteLift(idList) {
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deleteLift({ idList });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleAdd() {
      this.addLiftVisible = true;
    },
    exportLiftList() {
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let key in this.form) {
        if (this.form[key]) params[key] = this.form[key];
      }
      params.liftIdList = this.multipleSelection.map((item) => item.id);
      exportLiftList(params);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getListData();
    },
    handleAddLiftConfirm() {
      this.addLiftVisible = false;
      this.pageIndex = 1;
      this.getListData();
    },
    handleEditLiftConfirm() {
      this.editLiftVisible = false;
      this.getListData();
    },
    setPojectAddress(data) {
      this.form.address = data.addressData; // 项目地址 详细地址
      this.form.provinceCode = data.provinceCode; // 项目地址省级 code
      this.form.provinceName = data.provinceName; // 项目地址省级 name
      this.form.cityCode = data.cityCode; // 项目地址城市 code
      this.form.cityName = data.cityName; // 项目地址城市 name
      this.form.districtCode = data.townCode; // 项目地址区级 code
      this.form.districtName = data.townName; // 项目地址区级 name
      this.handleSearchListData();
    },
    stopMaintainConfirm() {
      this.showStopMaintain = false;
      this.getListData();
    },
    startMaintainConfirm() {
      this.showStartMaintain = false;
      this.getListData();
    },
    changeMaintainType(row) {
      this.liftDetail = { ...row };
      if (row.maintainStatus === 1) {
        this.showStopMaintain = true;
      } else {
        this.showStartMaintain = true;
      }
    },
    handleDepartment(val) {
      this.form.departmentIdList = [];
      if (val && val.length) {
        const nodes = this.$refs.cascader.getCheckedNodes();
        nodes.forEach((item) => {
          this.form.departmentIdList.push(item.data.id);
        });
      }
      this.handleSearchListData();
    },
    uploadFinish() {
      this.showImport = false;
      this.handleSearchListData();
    },
    handleInput() {
      this.showImport = true;
    },
    importRecords() {
      this.showRecord = true;
    },
    handleCommand(val, row) {
      if (val === "fuzhi") {
        this.handleEditCopy(row);
      } else if (val === "tingbao") {
        this.changeMaintainType(row);
      } else if (val === "erweima") {
        this.handleCheck(row);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-dropdown-link {
  cursor: pointer;
  color: #5b8cff;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/ElevatorManagement/ElevatorManagement.vue